import { cn } from '@core/utils/cn';

interface BrandMarkProps {
  readonly size?: number;
  readonly className?: string;
  /** Animate the bars like a sound-wave equalizer (staggered vertical pulse). */
  readonly animated?: boolean;
}

/** Equalizer logo — five bars, one teal — matching the landing page. */
export function BrandMark({ size = 26, className, animated = false }: BrandMarkProps): React.JSX.Element {
  const height = Math.round((size / 44) * 32);
  return (
    <svg
      className={cn(animated && 'dda-eq', className)}
      width={size}
      height={height}
      viewBox="0 0 44 32"
      fill="none"
      aria-hidden="true"
      focusable="false"
      style={{ overflow: 'visible' }}
    >
      <rect className="bar" x="0" y="9" width="6" height="14" rx="3" fill="var(--accent)" />
      <rect className="bar" x="9" y="3" width="6" height="26" rx="3" fill="var(--accent)" />
      <rect className="bar" x="18" y="12" width="6" height="8" rx="3" fill="var(--teal)" />
      <rect className="bar" x="27" y="1" width="6" height="30" rx="3" fill="var(--accent)" />
      <rect className="bar" x="36" y="7" width="6" height="18" rx="3" fill="var(--accent)" />
    </svg>
  );
}
